

module.exports = function (app) {
  app.registerComponent('navigation', '.js-navigation-panel', function (sb, el) {

    var navigationToggleEl = document.querySelector('.js-navigation-toggle')
    var panelExpanded = false;

    var togglePanel = function() {
      if (panelExpanded) {
        onNavigationCollapse();
      } else {
        document.body.classList.add('navigation-expanded')
        panelExpanded = true
      }
    }

    var onToggleClick = function() {
      togglePanel()
    }

    var onNavigationCollapse = function() {
        document.body.classList.remove('navigation-expanded')
        panelExpanded = false
    }

    sb.subscribe('navigation/collapse', onNavigationCollapse)
    /* INIT ------------------------------------------- */
    return {
      init: function () {

        navigationToggleEl.addEventListener('click', onToggleClick)
      },
      destroy: function () {
      }
    }
  })
}



// WEBPACK FOOTER //
// ./assets/js/components/navigation.js